export const IULI_ADMIN_FEATURES = {
  SUPPORT_COMPANIES_VIEW: 'support.companies.view',
  BLOG_MANAGE: 'blog.manage',
};

export const isKnownIuliAdminFeature = (feature) =>
  Object.values(IULI_ADMIN_FEATURES).includes(feature);

export const hasIuliAdminAccess = (user, feature) => {
  if (!user || !feature) {
    return false;
  }

  if (user.is_iuli_admin === true || user.is_iuli_admin === 1) {
    return true;
  }

  return (user.iuli_admin_grants || []).includes(feature);
};
